<template>
    <div class="game-info-list">
        <div class="funtion-zone">
            <div class="game-info-list-type">
                <div class="list-type-wrap">
                    <div class="type-item" :class="{ isSelected: currentTab == index }" :id="`type-item-${index}`"
                        @click="tabClick(index, item)" v-for="(item, index) in typeList" :key="index">
                        <div class="type-item-title">{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <div class="game-info-list-select" v-if="pageType == 'originListPage'">
                <div class="list-select-wrap">
                    <select @click="selectClick(index)" v-model="selectOptions[`${options.attr}`]"
                        class="list-select-wrap-item" :class="`list-select-wrap-item${index}`" :id="`select${index}`"
                        v-for="(options, index) in currentOption" :key="index">
                        <option selected hidden disabled value="no-select-title">{{ options.title }}</option>
                        <option value="no-select">不限</option>
                        <option v-for="(option, index2) in options.data" :key="index2" :value="option.key">
                            {{ option.name }}
                        </option>
                    </select>
                    <p class="notice">※更新時間：2月28日；實際內容以遊戲內為准</p>
                </div>
            </div>
        </div>
        <div class="general-module" v-if="pageType == 'originListPage'" id="originList">
            <div class="game-info-list-data">
                <div class="data-item" :class="columnType">
                    <gameObjCard @click.native="goDetail(item)" v-for="(item, index) in currentData" :key="index"
                        :type="currentType" :quality="item.quality" :name="item.name" :src="getImg(item.icon)"
                        :id="item.id" :sourceBgType="item.IconType">
                    </gameObjCard>
                </div>
            </div>
        </div>
        <div class="custom-module" v-if="pageType == 'customPage'">
            <component :is="currentComponent" :backendData="backendCustomData"></component>
        </div>
    </div>
</template>

<script>
import { typeEnum } from '../gameInfoConfig'
import lodash from 'lodash'
import gameObjCard from '../components/base/gameObjCard.vue'
import resourceCenter from './resourceCenter.vue'
import httpFunction from '@/api/get'
import getCdnImg from '@/utils/getCdnImg.js'
const techImg = getCdnImg('//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/characterHalf/')
const mechaImg = getCdnImg('//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/mecha/')
const packImg = getCdnImg('//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/pack/')
const weponImg = getCdnImg('//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/weapons/')
const skillImg = getCdnImg('//media.tentree-games.com/media/pictures/community/img/gl/gameInfo/skill/')
const { getGlGameinfo } = httpFunction
export default {
    components: { gameObjCard, resourceCenter },
    props: {
        initTabIndex: {
            type: Number,
            default: 0
        },
        typeList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentTab: 0,
            selectOptions: {},
            backendData: [],
            backendCustomData: [],
            currentComponent: '',
            testAttr: '1',
            mouseEvent: null
        }
    },
    //created() {
    // if (this.typeList[0] && this.typeList[0].dataSource) {
    //     switch (this.pageType) {
    //         case 'originListPage': {
    //             this.getData(this.typeList[0].dataSource)
    //             break
    //         }
    //         case 'customPage': {
    //             this.currentComponent = this.typeList[0].customComponent
    //             this.getCustomData(this.typeList[0].dataSource, this.typeList[0].dataForm)
    //             break
    //         }
    //         default: {
    //             break
    //         }
    //     }
    // }
    //},
    mounted() {
        //鼠标滚轮滚动时内层元素滚动
        //判断是否有滚轮wheel事件
        let mouse = null
        if ('onwheel' in document) {
            mouse = 'wheel'
        } else if ('onmousewheel' in document) {
            mouse = 'mousewheel'
        } else {
            // Firefox < 17
            mouse = null
        }

        if(mouse){
            window.addEventListener('wheel', this.customScroll)
        }
    },
    computed: {
        pageType() {
            return this.typeList[this.currentTab].pageType
        },
        columnType() {
            switch (this.currentType) {
                case typeEnum.TECHNICIAN: {
                    return 'size1'
                }
                case typeEnum.MECH: {
                    return 'size2'
                }
                case typeEnum.WEAPON: {
                    return 'size3'
                }
                case typeEnum.PACK: {
                    return 'size4'
                }
                case typeEnum.MODULE: {
                    return 'size5'
                }
                case typeEnum.COMPONENT: {
                    return 'size6'
                }
                default: {
                    return ''
                }
            }
        },
        currentType() {
            switch (this.pageType) {
                case 'originListPage': {
                    return this.typeList[this.currentTab].type
                }
                case 'customPage': {
                    return ''
                }
                default: {
                    return ''
                }
            }
        },
        currentOption() {
            switch (this.pageType) {
                case 'originListPage': {
                    return this.typeList[this.currentTab].selectOptions
                }
                case 'customPage': {
                    return []
                }
                default: {
                    return []
                }
            }
        },
        currentData() {
            switch (this.pageType) {
                case 'originListPage': {
                    if (this.backendData.length <= 0) {
                        return []
                    }
                    let keys = Object.keys(this.selectOptions)
                    let filterKey = []
                    if (keys && keys.length > 0) {
                        keys.forEach(key => {
                            if (this.selectOptions[key] != 'no-select' && this.selectOptions[key] != 'no-select-title') {
                                filterKey.push({ key: key, value: this.selectOptions[key] })
                            }
                        })
                        let result = lodash.cloneDeep(this.backendData)
                        filterKey.forEach(filter => {
                            result = result.filter(item => item[`${filter.key}`] == filter.value)
                        })
                        return this.sortList(result, this.currentType)
                    } else {
                        return this.sortList(this.backendData, this.currentType)
                    }
                }
                case 'customPage': {
                    return []
                }
                default: {
                    return []
                }
            }

        }
    },
    watch: {
        //监听currentOption
        currentOption: {
            handler() {
                this.resetSelectOptions()
            },
            immediate: true
        },
        initTabIndex: {
            handler() {
                this.currentTab = this.initTabIndex
            },
            immediate: true,
            deep: true
        },
        currentTab: {
            handler() {
                if (this.typeList[this.currentTab] && this.typeList[this.currentTab].dataSource) {
                    switch (this.pageType) {
                        case 'originListPage': {
                            this.backendData = []
                            this.getData(this.typeList[this.currentTab].dataSource)
                            let el = document.getElementsByClassName('general-module')[0]
                            if (el) {
                                el.scrollIntoView()
                            }
                            break
                        }
                        case 'customPage': {
                            this.backendData = []
                            this.currentComponent = this.typeList[this.currentTab].customComponent
                            this.getCustomData(this.typeList[this.currentTab].dataSource, this.typeList[0].dataForm)
                            break
                        }
                        default: {
                            break
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        sortList(data, type) {
            let SSSRData = []
            let URData = []
            let SSRData = []
            let SRData = []
            let RData = []
            SSSRData = data.filter(item => item.quality == 'SSSR')
            URData = data.filter(item => item.quality == 'UR')
            SSRData = data.filter(item => item.quality == 'SSR')
            SRData = data.filter(item => item.quality == 'SR')
            RData = data.filter(item => item.quality == 'R')
            if (type == 2) {
                let sortData = [SSSRData, URData, SSRData, SRData, RData]
                for (let i = 0; i < sortData.length; i++) {
                    let resultData = []
                    let lightData = []
                    let mediumData = []
                    let heavyData = []
                    lightData = sortData[i].filter(item => item.type == 'Light')
                    mediumData = sortData[i].filter(item => item.type == 'Medium')
                    heavyData = sortData[i].filter(item => item.type == 'Heavy')
                    resultData = [].concat(lightData, mediumData, heavyData)
                    sortData[i] = resultData
                }
                //数组扁平化
                return [].concat(...sortData)
            } else if(type == 3){
                let exData = []
                exData = SSRData.filter(item => item.name.includes('EX'))
                SSRData = SSRData.filter(item => !item.name.includes('EX'))
                return [].concat(SSSRData, URData, exData, SSRData, SRData, RData)
            } else {
                return [].concat(SSSRData, URData, SSRData, SRData, RData)
            }
        },
        getImg(iconName) {
            switch (this.currentType) {
                case 1: {
                    return techImg(`${iconName}.png`)
                }
                case 2: {
                    return mechaImg(`${iconName}.png`)
                }
                case 3: {
                    return weponImg(`${iconName}.png`)
                }
                case 4: {
                    return packImg(`${iconName}.png`)
                }
                case 5: {
                    return skillImg(`${iconName}.png`)
                }
                case 6: {
                    return skillImg(`${iconName}.png`)
                }
            }
        },
        resetSelectOptions() {
            this.selectOptions = {}
            for (let i = 0; i < this.currentOption.length; i++) {
                this.$set(this.selectOptions, `${this.currentOption[i].attr}`, 'no-select-title')
            }
        },
        tabClick(index, item) {
            this.currentTab = index
            let targetEl = document.getElementById(`type-item-${index}`)
            //移动到父元素横向中间
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            })
            // if (item.dataSource) {
            //     switch (this.pageType) {
            //         case 'originListPage': {
            //             this.backendData = []
            //             this.getData(item.dataSource)
            //             let el = document.getElementsByClassName('general-module')[0]
            //             if (el) {
            //                 el.scrollIntoView()
            //             }
            //             break
            //         }
            //         case 'customPage': {
            //             this.backendData = []
            //             this.currentComponent = item.customComponent
            //             this.getCustomData(item.dataSource, item.dataForm)
            //             break
            //         }
            //         default: {
            //             console.warn('not page type match')
            //             break
            //         }
            //     }
            // }
        },
        selectClick(index) {
            let targetEl = document.getElementById(`select${index}`)
            //移动到父元素横向中间
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            })
        },
        goDetail(item) {
            this.$emit('goDetail', {
                type: this.currentType,
                data: item
            })
        },
        getData(dataSource) {
            let form = {
                appkey: '1705460260139',
                target: dataSource,
                type: 'list'
            }
            getGlGameinfo(form)
                .then(res => {
                    let data = res.data && res.data.data ? res.data.data : []
                    this.backendData = data
                })
        },
        getCustomData(dataSource, dataForm) {
            let form = dataForm.apply(this)
            httpFunction[dataSource](form)
                .then(res => {
                    this.backendCustomData = res.data ? res.data.data ? res.data.data : [] : []
                })
        },
        customScroll(e) {
            let el = null;
            switch (this.pageType) {
                case 'originListPage': {
                    el = document.getElementById('originList')
                    break
                }
                case 'customPage': {
                    el = document.getElementById('customList')
                    break
                }
            }
            if (el) {
                //模拟scroll事件
                if (e.wheelDeltaY > 0) {
                    el.scrollTop -= 30
                } else {
                    el.scrollTop += 30
                }
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.customScroll)
    }
}
</script>


<style lang='scss' scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
    width: 0rem;
}

::-webkit-scrollbar:horizontal {
    height: 0rem;
}

.game-info-list {
    //padding: 0 0 1.6rem 0;
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-y: auto;

    .funtion-zone {
        padding: .32rem .3rem;
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 2;

        .game-info-list-type {
            height: .5rem;


            .list-type-wrap {
                height: 100%;
                display: flex;
                overflow-y: hidden;
                overflow-x: auto;
                user-select: none;
                cursor: pointer;

                .type-item {
                    flex-shrink: 0;
                    position: relative;

                    &-title {
                        font-size: .3rem;
                        font-weight: 500;
                    }

                    &.isSelected {
                        .type-item-title {
                            font-weight: bold;
                        }
                    }

                    &.isSelected::after {
                        //画个箭头朝下的三角形
                        content: '';
                        position: absolute;
                        bottom: 0rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 0;
                        height: 0;
                        border-left: .1rem solid transparent;
                        border-right: .1rem solid transparent;
                        border-top: .1rem solid #23323d;
                    }
                }

                .type-item:not(:last-child) {
                    margin-right: .8rem;
                }


            }

            .list-type-wrap::-webkit-scrollbar {
                display: none;
            }
        }

        .game-info-list-select {
            height: .38rem;
            margin-top: .25rem;

            .list-select-wrap {
                height: 100%;
                display: flex;
                overflow-x: auto;
                user-select: none;
                
                .notice{
                    font-size: .15rem;
                    color: #bccad6;
                    margin: auto 0;
                }

                &-item:not(:last-child) {
                    margin-right: .3rem;
                }

                &-item {
                    //美化原生select
                    flex-shrink: 0;
                    transition: all .5s;
                    border: .01rem solid #bccad6;
                    color: #bccad6;
                    width: 1.3rem;
                    outline: none;
                    padding: 0 .17rem;
                    -webkit-appearance: none;
                    /* Safari 和 Chrome */
                    -moz-appearance: none;
                    /* Firefox */
                    background: transparent;
                    background: url('../../../../../assets/img/gl/gameInfo/game_info_select_arrow.png') no-repeat 90% center;
                }
            }

            .list-select-wrap::-webkit-scrollbar {
                display: none;
            }
        }
    }




    &-data {
        .data-item {
            display: grid;
            justify-items: center;


            &.size1,
            &.size2 {
                grid-template-columns: repeat(auto-fill, 2.01rem);
                gap: .4rem;
            }

            &.size3,
            &.size4,
            &.size5,
            &.size6 {
                gap: .4rem;
                grid-template-columns: repeat(auto-fill, 1.4rem);
            }

            &.column-count-3 {
                grid-template-columns: repeat(3, 1fr);
                gap: .4rem;
            }

            &.column-count-4 {
                grid-template-columns: repeat(4, 1fr);
                gap: .4rem;
            }

            &.column-count-5 {
                grid-template-columns: repeat(5, 1fr);
                gap: .4rem;
            }

            &.column-count-6 {
                gap: .4rem;
                grid-template-columns: repeat(6, 1fr);
            }
        }
    }

    .custom-module,
    .general-module {
        position: relative;
        padding: 0 .3rem;
    }

    .custom-module {
        flex: 1;
        overflow: hidden;
    }

    .general-module {
        padding-bottom: 1.7rem;

    }
}

.isPad {
    .game-info-list {
        .general-module {
            flex: 1;
            overflow: hidden;
        }
    }
}
</style>
